module.exports = __webpack_public_path__ + "static/b444fda9343b3cc79b2e0018dda195649c013bca390f01fda745f13de86a4c72-586a31f4f9af9b80924fcbaa054c0a07.png";